import React from 'react';
import {inject, observer} from 'mobx-react';
import {
  LoginWrapper,
  Caption,
  SignInView,
  FormWrapper,
  ErrorNotification,
  StyledErrorWrapper,
  StyledErrorIcon,
  StyledText,
  StyledButtonLink,
  StyledIcon
} from './styles';
import {FormattedMessage} from '@swipe-guide/clients-shared/components/FormattedComponents';
import PhoneInput from '@swipe-guide/clients-shared/components/PhoneInput';
import messages from './messages';
import Field from '@swipe-guide/clients-shared/components/Field';
import {injectIntl} from 'react-intl';
import {bindField} from '@swipe-guide/clients-shared/utils/input-utils';
import {Button} from '@swipe-guide/clients-shared/components/Button';
import ActivationCodeForm from '@swipe-guide/clients-shared/stores/forms/activation-code-form';
import {SetPassword} from '@swipe-guide/clients-shared/api/password/mutations';
import {setPasswordOptions} from '@swipe-guide/clients-shared/api/password/mutation-options';
import {graphql} from '@apollo/client/react/hoc/graphql';
import {TOAST_NOTIFICATIONS_TYPES} from '@swipe-guide/clients-shared/enums';
import * as Sentry from '@sentry/react';

@injectIntl
@graphql(SetPassword, setPasswordOptions)
@inject('store')
@observer
export default class PhoneActivationCodeView extends React.Component {
  state = {
    loading: false
  };

  constructor(props) {
    super(props);
    this.form = new ActivationCodeForm();
  }

  onSubmit = async () => {
    const {
      intl: {formatMessage}
    } = this.props;

    const values = this.form.values();
    const passwordsMatch = values.password === values.passwordConfirm;
    if (!this.form.isValid || this.state.loading || !passwordsMatch) {
      return;
    }

    this.setState({loading: true});
    try {
      const {data} = await this.props.setPasswordMutation({
        token: values.activationCode,
        password: values.password,
        phoneNumber: values.phoneNumber
      });
      if (data.setPassword) {
        this.handleSuccess();
      } else {
        this.handleError(formatMessage(messages.invalidPhoneNumberOrCode));
      }
    } catch (e) {
      this.handleError(formatMessage(messages.thereWasAnError));
      Sentry.captureException(e);
    }

    this.setState({loading: false});
  };

  handleError = message => {
    const {
      toastNotifications: {addNotification}
    } = this.props.store;

    addNotification({
      message,
      type: TOAST_NOTIFICATIONS_TYPES.ERROR
    });
  };

  handleSuccess = () => {
    const {
      store: {
        toastNotifications: {addNotification}
      },
      intl: {formatMessage}
    } = this.props;

    addNotification({
      message: formatMessage(messages.passwordSuccessfullySet),
      type: TOAST_NOTIFICATIONS_TYPES.SUCCESS
    });
    this.props.onSuccess();
  };

  render() {
    const {intl} = this.props;
    const {form} = this;
    const {password, passwordConfirm} = form.values();
    const passwordsMatch = password === passwordConfirm;

    return (
      <SignInView>
        <LoginWrapper>
          <Caption>
            <FormattedMessage {...messages.activateAccount} />
          </Caption>

          <FormWrapper>
            <PhoneInput title={intl.formatMessage(messages.phoneNumber)} form={form} field="phoneNumber" hideError />
            <Field
              title={intl.formatMessage(messages.activationCode)}
              placeholder="000000"
              id="activationCode"
              type="number"
              form={form}
              field={'activationCode'}
              {...bindField(form, 'activationCode')}
              hideError
              onlyIntegers
              hideArrows
            />

            <Field
              title={intl.formatMessage(messages.newPassword)}
              placeholder="******"
              id="password"
              type="password"
              form={form}
              field={'password'}
              hideError
              withPasswordToggle
              withPasswordValidation
              {...bindField(form, 'password')}
            />
            <Field
              title={intl.formatMessage(messages.newPasswordConfirm)}
              placeholder="******"
              id="passwordConfirm"
              type="password"
              form={form}
              field={'passwordConfirm'}
              hideError
              {...bindField(form, 'passwordConfirm')}
              withPasswordToggle
            />
            {!passwordsMatch && (
              <StyledErrorWrapper>
                <StyledErrorIcon name={'warning'} />
                <ErrorNotification>{intl.formatMessage(messages.passwordsDoNotMatch)}</ErrorNotification>
              </StyledErrorWrapper>
            )}

            <Button
              disabled={!form.isValid || this.state.loading || !passwordsMatch}
              loading={this.state.loading}
              onClick={this.onSubmit}
              type="submit"
            >
              {intl.formatMessage(messages.submit)}
            </Button>

            <StyledText>
              <StyledButtonLink href={window.location.origin}>
                <StyledIcon name={'arrow-left'} />
                {intl.formatMessage(messages.returnToSignIn)}
              </StyledButtonLink>
            </StyledText>
          </FormWrapper>
        </LoginWrapper>
      </SignInView>
    );
  }
}
